import { render, staticRenderFns } from "./EmployerApproval.vue?vue&type=template&id=2a1086a9&scoped=true"
import script from "./EmployerApproval.vue?vue&type=script&lang=js"
export * from "./EmployerApproval.vue?vue&type=script&lang=js"
import style0 from "./EmployerApproval.vue?vue&type=style&index=0&id=2a1086a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1086a9",
  null
  
)

export default component.exports